import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../../components/base/SeoHead';

interface BlogPost {
  id: number;
  title: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  excerpt: string;
  author: string;
  authorImage: string;
}

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('全部');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogPosts: BlogPost[] = [
    {
      id: 1,
      title: '如何為寵物選擇安全的香氛產品',
      category: '寵物照顧',
      date: '2024-01-15',
      readTime: '5分鐘',
      image: 'https://public.readdy.ai/ai/img_res/72b4f69ee629a177c1476142a1cdda44.jpg',
      excerpt: '選擇寵物友善的香氛產品是每位毛孩家長的重要課題。本文將教您如何辨識安全的香氛成分，以及哪些精油對寵物有害...',
      author: '林芳儀',
      authorImage: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20aromatherapy%20expert%20portrait%20with%20clean%20white%20background%2C%20friendly%20smile%2C%20natural%20style&width=200&height=200&seq=author1&orientation=squarish'
    },
    {
      id: 2,
      title: '香氛蠟燭製作入門指南',
      category: '香氛知識',
      date: '2024-01-12',
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20handmade%20scented%20candles%20arrangement%20with%20natural%20ingredients%20on%20clean%20white%20surface%2C%20candle%20making%20tutorial%20scene%2C%20soft%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20aromatherapy%20crafting%20guide%20visual&width=800&height=600&seq=blog2&orientation=landscape',
      excerpt: '想要親手製作香氛蠟燭嗎？從選擇蠟材、調配香氛到倒模技巧，這篇完整指南將帶您一步步完成第一個手作蠟燭...',
      author: '陳雅婷',
      authorImage: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20candle%20maker%20portrait%20with%20clean%20white%20background%2C%20warm%20smile%2C%20artistic%20style&width=200&height=200&seq=author2&orientation=squarish'
    },
    {
      id: 3,
      title: '寵物空氣清淨機的選購要點',
      category: '產品指南',
      date: '2024-01-10',
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=modern%20white%20air%20purifier%20in%20clean%20bright%20room%20with%20happy%20pets%2C%20pet-friendly%20home%20appliance%2C%20minimalist%20interior%20design%2C%20soft%20natural%20lighting%2C%20professional%20product%20lifestyle%20photography%20on%20white%20background&width=800&height=600&seq=blog3&orientation=landscape',
      excerpt: '寵物家庭需要特別注意空氣品質。本文將介紹選購寵物空氣清淨機時應注意的關鍵規格，包括CADR值、濾網類型等...',
      author: '王美玲',
      authorImage: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20pet%20care%20expert%20portrait%20with%20clean%20white%20background%2C%20gentle%20smile%2C%20professional%20style&width=200&height=200&seq=author3&orientation=squarish'
    },
    {
      id: 4,
      title: '薰衣草精油的多種用途',
      category: '香氛知識',
      date: '2024-01-08',
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=lavender%20essential%20oil%20bottle%20with%20fresh%20lavender%20flowers%20on%20clean%20white%20surface%2C%20aromatherapy%20product%2C%20soft%20natural%20lighting%2C%20minimalist%20style%2C%20professional%20product%20photography&width=800&height=600&seq=blog4&orientation=landscape',
      excerpt: '薰衣草精油是最受歡迎的精油之一。除了舒緩放鬆，它還有許多實用功能。讓我們一起探索薰衣草精油的神奇用途...',
      author: '林芳儀',
      authorImage: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20aromatherapy%20expert%20portrait%20with%20clean%20white%20background%2C%20friendly%20smile%2C%20natural%20style&width=200&height=200&seq=author1&orientation=squarish'
    },
    {
      id: 5,
      title: '打造寵物友善的居家環境',
      category: '寵物照顧',
      date: '2024-01-05',
      readTime: '9分鐘',
      image: 'https://readdy.ai/api/search-image?query=cozy%20pet-friendly%20modern%20home%20interior%20with%20happy%20dog%20and%20cat%2C%20clean%20bright%20space%20with%20plants%2C%20comfortable%20living%20room%2C%20natural%20lighting%2C%20professional%20lifestyle%20photography&width=800&height=600&seq=blog5&orientation=landscape',
      excerpt: '為毛孩打造一個安全舒適的家是每位飼主的心願。從空氣品質到香氛選擇，本文提供完整的居家環境規劃建議...',
      author: '王美玲',
      authorImage: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20pet%20care%20expert%20portrait%20with%20clean%20white%20background%2C%20gentle%20smile%2C%20professional%20style&width=200&height=200&seq=author3&orientation=squarish'
    },
    {
      id: 6,
      title: '天然手工皂的製作秘訣',
      category: '香氛知識',
      date: '2024-01-03',
      readTime: '10分鐘',
      image: 'https://readdy.ai/api/search-image?query=natural%20handmade%20soap%20bars%20with%20herbs%20and%20essential%20oils%20on%20clean%20white%20surface%2C%20artisan%20soap%20making%2C%20soft%20lighting%2C%20minimalist%20aesthetic%2C%20professional%20product%20photography&width=800&height=600&seq=blog6&orientation=landscape',
      excerpt: '手工皂製作看似簡單，但要做出品質優良的成品需要掌握許多技巧。本文分享專業皂師的製皂秘訣與常見問題解答...',
      author: '陳雅婷',
      authorImage: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20candle%20maker%20portrait%20with%20clean%20white%20background%2C%20warm%20smile%2C%20artistic%20style&width=200&height=200&seq=author2&orientation=squarish'
    }
  ];

  const categories = ['全部', '寵物照顧', '香氛知識', '產品指南'];

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === '全部' || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const popularPosts = blogPosts.slice(0, 5);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mofu.com.tw';

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/blog#webpage`,
        "url": `${siteUrl}/blog`,
        "name": "部落格 - 寵物照顧與香氛生活知識 | MOFU 淨寵居",
        "description": "MOFU 淨寵居部落格分享寵物照顧、香氛知識、產品指南等實用資訊。",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首頁", "item": siteUrl },
            { "@type": "ListItem", "position": 2, "name": "部落格", "item": `${siteUrl}/blog` }
          ]
        }
      },
      {
        "@type": "Blog",
        "name": "MOFU 淨寵居部落格",
        "description": "分享寵物照顧與香氛生活的實用資訊",
        "url": `${siteUrl}/blog`,
        "publisher": {
          "@type": "Organization",
          "name": "MOFU 淨寵居",
          "url": siteUrl,
          "logo": {
            "@type": "ImageObject",
            "url": "https://static.readdy.ai/image/1951b0480a7991f717d8723701e95243/c0ff92e5a82252bc47aa78b3b10aa452.png"
          }
        },
        "blogPost": blogPosts.slice(0, 6).map(post => ({
          "@type": "BlogPosting",
          "headline": post.title,
          "description": post.excerpt,
          "image": post.image,
          "datePublished": post.date,
          "author": {
            "@type": "Person",
            "name": post.author
          },
          "publisher": {
            "@type": "Organization",
            "name": "MOFU 淨寵居"
          },
          "url": `${siteUrl}/blog/${post.id}`,
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `${siteUrl}/blog/${post.id}`
          }
        }))
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      <SeoHead
        title="部落格 - 寵物照顧與香氛生活知識 | MOFU 淨寵居"
        description="MOFU 淨寵居部落格分享寵物照顧、香氛知識、產品指南等實用資訊。了解如何為寵物選擇安全的香氛產品、香氛蠟燭製作技巧、寵物空氣清淨機選購要點等專業知識。寵物照顧、香氛知識、寵物友善產品一次掌握。"
        keywords="寵物照顧,香氛知識,寵物友善產品,香氛蠟燭製作,空氣清淨機選購"
        ogImage={blogPosts[0]?.image}
        schema={schema}
      />

      {/* Header */}
      <div className="bg-gray-50 py-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            部落格
          </h1>
          <p className="text-gray-600 text-lg">分享寵物照顧與香氛生活的實用資訊</p>
        </div>
      </div>

      {/* Featured Post */}
      {filteredPosts.length > 0 && (
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <Link
              to={`/blog/${filteredPosts[0].id}`}
              className="group grid grid-cols-1 lg:grid-cols-5 gap-8 bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="lg:col-span-3 relative h-96 lg:h-auto overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={filteredPosts[0].image}
                    alt={filteredPosts[0].title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="lg:col-span-2 p-8 lg:p-12 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 bg-coral-100 text-coral-500 rounded-full text-sm font-medium mb-4 w-fit whitespace-nowrap">
                  {filteredPosts[0].category}
                </span>
                <h2 className="text-4xl font-bold text-gray-800 mb-4 group-hover:text-coral-500 transition-colors" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {filteredPosts[0].title}
                </h2>
                <p className="text-gray-600 mb-6 line-clamp-3">{filteredPosts[0].excerpt}</p>
                <div className="flex items-center gap-4 text-sm text-gray-500">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full overflow-hidden">
                      <img src={filteredPosts[0].authorImage} alt={filteredPosts[0].author} className="w-full h-full object-cover object-top" />
                    </div>
                    <span>{filteredPosts[0].author}</span>
                  </div>
                  <span>·</span>
                  <span>{filteredPosts[0].date}</span>
                  <span>·</span>
                  <span>{filteredPosts[0].readTime}</span>
                </div>
              </div>
            </Link>
          </div>
        </section>
      )}

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Main Content */}
          <div className="flex-1">
            {/* Category Filter */}
            <div className="flex flex-wrap gap-3 mb-8">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-coral-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Blog Posts */}
            <div className="space-y-8">
              {filteredPosts.slice(1).map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.id}`}
                  className="group flex flex-col md:flex-row gap-6 bg-white rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
                >
                  <div className="md:w-2/5 relative h-64 md:h-auto overflow-hidden">
                    <div className="w-full h-full">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  </div>
                  <div className="md:w-3/5 p-6 flex flex-col justify-center">
                    <span className="inline-block px-3 py-1 bg-coral-100 text-coral-500 rounded-full text-xs font-medium mb-3 w-fit whitespace-nowrap">
                      {post.category}
                    </span>
                    <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-coral-500 transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-2">{post.excerpt}</p>
                    <div className="flex items-center gap-4 text-sm text-gray-500">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full overflow-hidden">
                          <img src={post.authorImage} alt={post.author} className="w-full h-full object-cover object-top" />
                        </div>
                        <span>{post.author}</span>
                      </div>
                      <span>·</span>
                      <span>{post.date}</span>
                      <span>·</span>
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-80 flex-shrink-0">
            <div className="sticky top-24 space-y-8">
              {/* Search */}
              <div className="bg-white rounded-3xl p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-800 mb-4">搜尋文章</h3>
                <div className="relative">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="輸入關鍵字..."
                    className="w-full px-4 py-3 pr-12 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-coral-500 transition-colors text-sm"
                  />
                  <button className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-coral-500 transition-colors cursor-pointer">
                    <i className="ri-search-line text-xl"></i>
                  </button>
                </div>
              </div>

              {/* Popular Posts */}
              <div className="bg-white rounded-3xl p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-800 mb-4">熱門文章</h3>
                <div className="space-y-4">
                  {popularPosts.map((post) => (
                    <Link
                      key={post.id}
                      to={`/blog/${post.id}`}
                      className="group flex gap-3 cursor-pointer"
                    >
                      <div className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden">
                        <div className="w-full h-full">
                          <img
                            src={post.image}
                            alt={post.title}
                            className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                          />
                        </div>
                      </div>
                      <div className="flex-1">
                        <h4 className="text-sm font-medium text-gray-800 line-clamp-2 group-hover:text-coral-500 transition-colors mb-1">
                          {post.title}
                        </h4>
                        <p className="text-xs text-gray-500">{post.date}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Tags */}
              <div className="bg-white rounded-3xl p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-800 mb-4">熱門標籤</h3>
                <div className="flex flex-wrap gap-2">
                  {['寵物照顧', '香氛', '空氣清淨', '手作課程', '精油', '蠟燭', '擴香', '手工皂'].map((tag) => (
                    <button
                      key={tag}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-coral-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}